import { classNames } from "../../../../helpers/classNames";
import MediaCard from "../../../elements/MediaCard";

const ViewAllFile = ({
  list,
  isSelected,
  toggleSelectedItem,
  handleNavigate,
  onScroll = () => {},
}) => {
  return (
    <div
      className={classNames(
        "overflow-auto py-4 scroll-smooth h-[calc(100vh-150px)] w-full pr-2"
      )}
      onScroll={(e) => {
        onScroll({
          scrollTop: e.target.scrollTop,
          clientHeight: e.target.clientHeight,
          scrollHeight: e.target.scrollHeight,
        });
      }}
    >
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-6 gap-4 w-full">
        {list?.data?.map((file, index) => (
          <MediaCard
            key={index}
            file={file}
            isSelected={isSelected}
            toggleSelectedItem={toggleSelectedItem}
            onFolderClick={(folder) => {
              if (folder?.uid && folder?.name) {
                handleNavigate({ uid: folder?.uid, name: folder?.name });
              }
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ViewAllFile;
